import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { fg } from '@confluence/feature-gating';

import { ContentToolsItemPlaceholder } from './ContentToolsItemPlaceholder.tsx';

export const LazyContentToolsItem = LoadableLazy({
	loader: async () =>
		fg('confluence_link_item_append_trace_context')
			? (
					await import(
						/* webpackChunkName: "loadable-ContentToolsItemWithRoutesContext" */ './ContentToolsItemWithRoutesContext.tsx'
					)
				).ContentToolsItemWithRoutesContext
			: (await import(/* webpackChunkName: "loadable-ContentToolsItem" */ './ContentToolsItem.tsx'))
					.ContentToolsItem,
});

export const LazyContentToolsItemWithPlaceholder = LoadableLazy({
	loader: async () =>
		fg('confluence_link_item_append_trace_context')
			? (
					await import(
						/* webpackChunkName: "loadable-ContentToolsItemWithRoutesContext" */ './ContentToolsItemWithRoutesContext.tsx'
					)
				).ContentToolsItemWithRoutesContext
			: (await import(/* webpackChunkName: "loadable-ContentToolsItem" */ './ContentToolsItem.tsx'))
					.ContentToolsItem,
	loading: () => <ContentToolsItemPlaceholder />,
});
